import { RegisterModule } from '@/typings/common'
import {
  LkNotificationPagesState,
  LkNotificationPagesGetters,
  LkNotificationPagesMutations,
  LkNotificationPagesActions,
} from './store'
import { createMapper, registerModule as vuexRegisterModule, Module } from 'vuex-smart-module'
import { MODULE_NAME } from '../utils'


const storeModule = (
  new Module({
    namespaced: true,
    state: LkNotificationPagesState,
    getters: LkNotificationPagesGetters,
    mutations: LkNotificationPagesMutations,
    actions: LkNotificationPagesActions,
  })
)

const mapper = createMapper(storeModule)

export {
  storeModule as lkNotificationPagesStoreModule,
  mapper as lkNotificationPagesMapper,
}

export const registerModule: RegisterModule = ({ store }): void => {
  if (registerModule.installed) return

  vuexRegisterModule(
    store,
    MODULE_NAME,
    MODULE_NAME,
    storeModule,
  )

  registerModule.installed = true
}
